import PropTypes from 'prop-types';
import React from 'react';
import cx from "classnames";
import { GatsbyImage } from "gatsby-plugin-image";
import './Section.scss';

const Section = ({
  children,
  className,
  size,
  color,
  stripes,
  anchor,
  forwardedRef,
  backgroundImage,
  ...props
}) => {
  const classes = cx('section', {
		[`section--${className}`]: className,
	});
  return (
    <>
      <section
        className={classes}
        data-size={size}
        data-color={color}
        data-stripes={stripes}
        ref={forwardedRef}
        id={anchor}
        style={{ '--bgr-hero': `var(--color-${color})` }}
        {...props}
        >
      {/* {anchor && <a className="section__anchor" name={anchor}></a>} */}
      {backgroundImage && (
        <div className="sky-bgr">
          <GatsbyImage image={backgroundImage} alt="" className="sky-bgr__img jsSkyBgr" />
        </div>
      )}

        <div className="section__inner">
          {children}
        </div>
      </section>
    </>
)};

Section.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
  stripes: PropTypes.string,
  anchor: PropTypes.string,
  backgroundImage: PropTypes.object,
};

Section.defaultProps = {
  className: 'default',
  size: 'fixed',
  color: null,
  stripes: null,
  anchor: undefined,
  background: undefined
};

export default Section;
